import { first } from 'lodash';

export const PRINT_PATH_SENTINEL = '__print';
/**
 * Helper function to check if the current page is in print mode
 * @returns true if the URL pathname includes '__print'
 */
export function isPrintPath(): boolean {
  if (typeof window === 'undefined') return false;

  return (
    first(window.location.pathname.substring(1).split('/')) ===
    PRINT_PATH_SENTINEL
  );
}
